<template>
  <div class="images-list">
    <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleUploadError"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
      :show-file-list="showList"
      :file-list="fileList"
      ref="upload"
      :multiple="fileLimit > 1"
      :data="paramsData"
      :limit="fileLimit"
      :list-type="listType"
    >
      <img v-if="!showList && imgurl" :src="imgurl" class="avatar" />
      <i v-if="listType === 'picture-card' && !imgurl" class="el-icon-plus"></i>
      <el-button v-if="listType != 'picture-card'" size="small" type="primary"
        >{{$t('AAAA.clickUpload')}}</el-button
      >
      <div v-if="showTip" slot="tip" class="el-upload__tip">
        {{ $t('AAAA.onlyUploadFileType') }} {{ fileTypeName || "jpg/png" }} {{ $t('AAAA.fileSizeLimit') }} {{ fileSize }}MB
      </div>
      <!-- <div slot="file" slot-scope="{file}">
      <img
        class="el-upload-list__item-thumbnail"
        :src="file.url" alt=""
      >
      <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>

      </span>
    </div> -->
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { getToken } from "@/util/auth";
export default {
  name: "fileUpload ",
  props: {
    // 值
    value: [String, Object, Array],
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 10,
    },
    // 文件类型, 例如["doc", "xls", "ppt", "txt", "pdf"]
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 文件列表类型 text/picture/picture-card
    listType: {
      type: String,
      default: "picture",
    },

    showList: {
      type: Boolean,
      default: true,
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 最大允许上传个数
    fileLimit: {
      type: Number,
      default: 99,
    },
  },
  data() {
    return {
      uploadUrl:
        "http://apptest.wanguo-tech.com/api/blade-resource/oss/endpoint/put-file", // 上传的图片服务器地址
      paramsData: {}, // 上传携带的参数，看需求要不要
      fileList: [],
      tempFileList: [], // 因为 fileList为只读属性，所以用了一个中间变量来进行数据改变的交互。
      imgurl: "",
      dialogImageUrl: '',
        dialogVisible: false,
    };
  },
  watch: {
    value: {
      handler: function (newVal, oldVa) {

        if (newVal&&(!oldVa||oldVa.length<1)) {
          this.fileList = newVal
          if (!this.showList) {
            this.imgurl = newVal[0]&&newVal[0].url;
          }
          this.tempFileList = newVal;
        }
        console.log(newVal,22222222222222);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    fileTypeName() {
      let typeName = "";
      this.fileType.forEach((item) => {
        typeName += `${item}，`;
      });
      return typeName;
    },
    fileAccept() {
      let fileAccept = "";
      this.fileType.forEach((element) => {
        fileAccept += `.${element},`;
      });
      return fileAccept;
    },
  },
  created() {
    this.$nextTick(() => {
      // this.fileList = JSON.parse(JSON.stringify(this.value));
      // if (!this.showList) {
      //   this.imgurl = this.fileList.length > 0 ? this.fileList[0].url : "";
      // }
    });
    console.log(this.$router.currentRoute.fullPath);
  },
  methods: {
    async clearAll() {
      await this.$refs.upload.clearFiles()
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      console.log(this.fileList);
      if (!this.showList) {
        // this.fileList = []
      }
      if (this.fileType && file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk & file) {
          this.$message.error(
            `${this.$t('AAAA.fileFormatIncorrect')}${this.fileType.join("/")}${this.$t('AAAA.formatFile')}`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize && file) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`${this.$t('AAAA.uploadFileSizeExceed')} ${this.fileSize} MB!`);
          return false;
        }
      }

      return true;
    },
    handleUploadError(err) {
      this.$message.error(this.$t('AAAA.uploadFailed'));
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(this.$t('AAAA.exceedUploadFileCount'));
    },
    // 文件上传成功的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success(this.$t('AAAA.uploadSuccess'));
      if (!this.showList) {
        this.imgurl = res.data.link;
      }
      this.changeFileList(fileList);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.changeFileList(fileList);
    },
    // 文件列表改变的时候，更新组件的v-model的文的数据
    changeFileList(fileList) {
      console.log(fileList);
      const tempFileList = fileList.map((item) => {
        let tempItem = {
          name: item.name,
          url: item.response ? item.response.data.link : item.url,
        };
        return tempItem;
      });
      this.$emit("input", tempFileList);
      console.log(tempFileList,333333333)
      if (!this.showList) {
        this.$refs.upload.clearFiles();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 100%;
  height: 100%;
}
</style>


